import { connect } from 'react-redux';

import getExperiments from 'shared/redux/server/actions/experiments/get';
import { getEnabledExperimentsList } from 'shared/selectors/experiments';


@connect(state => ({
  isLoaded: Boolean(state.experiments),
  enabledExperiments: getEnabledExperimentsList(state).join(', '),
}), {
  getExperiments,
})
export default class ExperimentsLoader extends React.PureComponent {
  static propTypes = {
    getExperiments: React.PropTypes.func,
    enabledExperiments: React.PropTypes.string,
    isLoaded: React.PropTypes.bool,
    children: React.PropTypes.any,
  };

  componentDidMount() {
    this.props.getExperiments();
  }

  componentDidUpdate() {
    document.body.setAttribute('data-experiments', this.props.enabledExperiments);
  }

  render() {
    const { isLoaded, children } = this.props;

    if (!isLoaded) {
      return null;
    }

    return (
      <span>
        {children}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/data-components/experiments.js